import { j as N } from "../../jsx-runtime-B6kdoens.js";
import { a as A } from "../../index-CROKJrb5.js";
import { c as h, f as C } from "../../create-component-CBAeEoQ6.js";
import { u as R } from "../../use-merge-refs-DEJnLwh4.js";
import { u as S } from "../../use-breakpoints-Kqi6S3m8.js";
import { u as w } from "../../use-dimensions-CSpaxs3M.js";
import { w as j } from "../../atom-provider-B3P183Tj.js";
import { u as s } from "../../use-sync-atom-value-CDr7vapO.js";
import { c as k, N as B, u as I } from "../../NavigationState-EOPjgMu1.js";
import { u as b } from "../../use-unique-id-BA9hSqap.js";
const X = j(
  h(
    "Navigation",
    C(
      ({ as: o, children: i, className: r, forceCollapse: e = !1, id: a, ...n }, m) => {
        const u = o || "nav", c = b("navigation", a), [f, t] = w(), p = R(m, f), { isXSmall: l, isSmall: v } = S(t == null ? void 0 : t.width), d = !!(e || l || v), { idAtom: g, isBreakpointCollapsedAtom: x } = I();
        return s(g, a), s(x, d), /* @__PURE__ */ N.jsx(
          u,
          {
            ref: p,
            role: o && o !== "nav" ? "navigation" : null,
            className: A("cur-z-20 cur-flex cur-h-17 md:cur-h-20", r),
            id: c,
            ...n,
            children: i
          }
        );
      }
    )
  ),
  B,
  k
);
export {
  X as Navigation
};
//# sourceMappingURL=index.js.map
